export const pushGTMEvent = (nav_element: string, nav_action: string, menu_level?: string) =>
  window?.dataLayer?.push({ event: 'navigation', nav_element, nav_type: 'click', nav_action, menu_level: menu_level ? menu_level : null });

export const pushtoGTM = (event: string, nav_element: string, nav_type: string, nav_action: string) =>
  window?.dataLayer?.push({ event, nav_element, nav_type, nav_action });
